import { get, post, put, del, download } from './fetch';
import type { TestResult } from '../pages/test/types';

export interface Test {
  name: string;
  prize: number;
  testTime: number;
  error?: string;
}
export interface Questions {
  questions: Array<any>;
}
type TestType = 'default' | 'monthly';

export const sendResult = async (id: number, attemptId: number, answers: any, testType: TestType = 'default'): Promise<TestResult> => {
    return await post<TestResult>(`/test/${id}/result`, { attemptId, answers, testType });
};
export const startTest = async (id: number, isResume = false, testType: TestType = 'default'): Promise<any> => {
    return await post<any>(`/test/${id}/start`, { isResume, testType });
};
export const getTest = async (id: number, testType: TestType = 'default'): Promise<Test> => {
    return await get<Test>(`/test/${id}?testType=${testType}`);
};
export const getMonthlyTests = async () => {
    return await get<any[]>(`/test?testType=monthly`);
};
export const createMonthlyTest = async (data: any) => {
    return await post<any>('/test/save', { ...data, testType: 'monthly' });
};
export const updateMonthlyTest = async (id: number, data: any) => {
    return await put<any>(`/test/${id}`, { ...data, testType: 'monthly' });
};
export const deleteMonthlyTest = async (id: number) => {
    return await del<any>(`/test/${id}?testType=monthly`);
};
export const editMonthlyTestMaterials = async (id: number, materials: { materialId: number, questionsAmount: number }[]) => {
    return await post<any>(`/test/${id}/edit`, { materials, testType: 'monthly' });
};
export const testStat = async (): Promise<{
    success: Array<{ name: string; date: string; attemptsCount: number }>;
    uniqueSuccessCount: number;
    totalSuccessAttempts: number;
}> => {
    return await get(`/test/stat`);
};
export const editPrizes = async (materialId: number, managerId: string, prizes: string): Promise<boolean> => {
    return await post<boolean>('/test/editPrizes', {materialId, managerId, prizes});
};
export const exportTest = async (materialId: number, format: 'docx' | 'xlsx'): Promise<{ blob: Blob; filename: string }> => {
    return await download(`/test/export?materialId=${materialId}&format=${format}`, `test_${materialId}.${format}`);
};

